module.exports = __webpack_public_path__ + "static/media/poster14.1c8ac07e.png";